import { useState, useEffect } from 'react'
import './App.css'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Header from './components/commons/header/header'
import Footer from './components/commons/footer/footer'
import { ROUTES } from './providers/router';
import { stickyNavigation } from './hooks/sticky-navigation'
import type { HeaderStyleParams } from './interfaces/headerStyleParams'
import i18n from "./utils/i18n";
import { useLocation } from "react-router-dom"


function App() {
  // Initialise lang correctement avec fallback

  const location = useLocation();
  const lang = location.pathname.split('/')[1];

  const pageClassName = 'noname';
  const headerMenu = document.querySelector('#header-menu') as HTMLElement;
  const [headerHeight, setHeaderHeight ] = useState(headerMenu?.offsetHeight);
  const [headerDatas, setHeaderDatas ] = useState<HeaderStyleParams>({
     logoSize:100
  });

  useEffect(() => {
    const lang = location.pathname.split('/')[1];
    if (lang) {
        i18n.changeLanguage(lang);
    }
  }, [location.pathname]);

  stickyNavigation(()=>{
    setHeaderHeight(headerMenu.offsetHeight);
    if( window.scrollY > headerHeight){
      setHeaderDatas({ 
        sticky:true
      });
    }else{
      setHeaderDatas({sticky:false});
    }
  })

  




  const defaultLang = import.meta.env.VITE_DEFAULT_LANG;
  const browserlang = navigator.language.startsWith(defaultLang)?'fr':'en';


  return (
    <div style={{marginTop:headerDatas.sticky?headerHeight:""}} className={pageClassName + " " + (headerDatas.sticky===true?"nav-fix":'')} >
      <Toaster position="top-right" reverseOrder={false} />
        <Header styleParams = {headerDatas} />
        <Routes>
          <Route path='/' element={<Navigate to ={`${browserlang}`} replace/>}></Route>
          {ROUTES.map((route) => {
            let extraProps = { ...route.extraProps }
            // Calcul dynamique du slug si nécessaire
            if (extraProps?.slugPrefix) {
              extraProps.slug = `${extraProps.slugPrefix}${lang}`;
              delete extraProps.slugPrefix;
            }
            return (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            )
          })}
        </Routes>
        <Footer />
    </div>
  )
}
export default App

